import { themes, fonts } from './index';

export const applyTheme = (themeName) => {
  const theme = themes[themeName];
  if (!theme) return;

  const root = document.documentElement;
  
  // Apply theme colors as CSS variables
  Object.entries(theme.colors).forEach(([property, value]) => {
    root.style.setProperty(property, value);
  });
  
  // Apply dark class for Tailwind
  if (themeName === 'dark') {
    root.classList.add('dark');
  } else {
    root.classList.remove('dark');
  }
  
  // Store theme preference
  localStorage.setItem('theme', themeName);
};

export const applyFont = (fontName) => {
  const fontFamily = fonts[fontName];
  if (!fontFamily) return;

  const root = document.documentElement;
  root.style.setProperty('--font-family', fontFamily);
  
  // Store font preference
  localStorage.setItem('font', fontName);
};

export const getStoredTheme = () => {
  return localStorage.getItem('theme') || 'light';
};

export const getStoredFont = () => {
  return localStorage.getItem('font') || 'Inter';
};
